import React from 'react';

const Error = () => {
    return (
        <div className=' text-center'>
            <h1> Not found 404</h1>
            <p>this page is not set up route</p>
        </div>
    );
};

export default Error;